import './Spinner.css'

export default function Spinner() {
    return (
        <svg className="spinner" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle className="path" fill="none" stroke="#6666ff" strokeWidth="8" strokeLinecap="round" cx="33" cy="33" r="29" />
        </svg>
    )
}